module.exports = __webpack_public_path__ + "media/images/writer/follow_up_mailer/video_1-890eca2b4d404640656a66f1af1026de.png";